import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export const CountBadge = ({
  count,
  className,
}: {
  count: number
  className?: string
}): ReactNode => (
  <span
    className={twMerge(
      'inline-flex h-6 min-w-6 items-center justify-center rounded-full border border-brand-primary/20 px-2 text-sm font-semibold text-brand-primary',
      className,
    )}
  >
    {count}
  </span>
)
